export default "__VITE_ASSET__D_qtXU0M__"